import React from 'react';
import {Box, Typography} from '@mui/material';
import {useDrawAnnotation} from '../hooks/useDrawAnnotation';
import PdfDocumentRenderer from '../PdfDocumentRenderer/PdfDocumentRenderer';
import useWheelZoom from '../hooks/useWheelZoom';
import {useTheme} from '@mui/material/styles';
import {useTranslation} from "react-i18next";


function PdfScrollContainer(props) {
    const {
        file, viewerRef, pageRefs, onDocumentLoadSuccess,
        scale, numPages, highlights, onBoxClick, onBoxHover, selectedAnnotations,onDissociateAnnotation,
        onZoomIn, onZoomOut, isDrawing, onAddAnnotation, onFinishDrawing,
        updateAnnotation,
        provider,
        model,
        onRemoveAnnotation,
        onUpdateAnnotationPosition,
        selectionRect,
        selectionPage,
        selectionHandlers,
        groupingTempKeys,
        multiSelectMode,
        peekKey,
        hoveredKey,
        suppressProcessing
    } = props;

    const {
        containerRef,
        handleMouseDown,
        handleMouseMove,
        handleMouseUp,
        currentRect,
        currentPage,
    } = useDrawAnnotation({
        pageRefs,
        scale,
        onAddAnnotation,
        onFinishDrawing,
        isDrawing,
        updateAnnotation,
        provider,
        model,
        suppressProcessing
    });

    const {t} = useTranslation();

    const theme = useTheme();

    useWheelZoom(containerRef, onZoomIn, onZoomOut);


    // small teal pencil cursor (hotspot near the tip)
    const PENCIL_CURSOR = `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='28' height='28' viewBox='0 0 24 24'%3E%3Cpath fill='none' stroke='%230d9488' stroke-width='2' d='M3 21l3-1 12-12-2-2L4 18l-1 3z'/%3E%3Ccircle cx='19' cy='5' r='1.4' fill='%230d9488'/%3E%3C/svg%3E") 2 22, crosshair`;

    return (
        <Box
            tabIndex={-1}
            onMouseDown={(e) => {
                if (isDrawing) handleMouseDown(e);
                else selectionHandlers?.handleMouseDown?.(e);
            }}
            onMouseMove={(e) => {
                if (isDrawing) handleMouseMove(e);
                else selectionHandlers?.handleMouseMove?.(e);
            }}
            onMouseUp={(e) => {
                if (isDrawing) handleMouseUp(e);
                else selectionHandlers?.handleMouseUp?.(e);
            }}
            ref={(el) => {
                viewerRef.current = el;
                containerRef.current = el;
            }}
            sx={{
                flexGrow: 1,
                overflow: 'auto',
                width: '100%',
                py: 2,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                gap: 2,
                backgroundColor: 'transparent',
                cursor: isDrawing ? PENCIL_CURSOR : 'default',
                '& *': {cursor: isDrawing ? PENCIL_CURSOR : 'inherit'} // make it feel consistent over children
            }}
        >
            {file ? (
                <PdfDocumentRenderer
                    file={file}
                    numPages={numPages}
                    scale={scale}
                    highlights={highlights}
                    pageRefs={pageRefs}
                    selectedAnnotations={selectedAnnotations}
                    onBoxClick={onBoxClick}
                    onDocumentLoadSuccess={onDocumentLoadSuccess}
                    onDissociateAnnotation={onDissociateAnnotation}
                    isDrawing={isDrawing}
                    currentRect={currentRect || selectionRect}
                    currentPage={currentPage != null ? currentPage : selectionPage}
                    onRemoveAnnotation={onRemoveAnnotation}
                    onUpdateAnnotationPosition={onUpdateAnnotationPosition}
                    groupingTempKeys={groupingTempKeys}
                    multiSelectMode={multiSelectMode}
                    peekKey={peekKey}
                    hoveredKey={hoveredKey}
                    onBoxHover={onBoxHover}
                />
            ) : (
                <Typography sx={{color: theme.palette.secondary.contrastText}}>{t("no_file_selected")}</Typography>
            )}
        </Box>
    );
}

export default PdfScrollContainer;
